import { Box, Flex } from '@sequencehq/core-components'
import { MouseEventHandler } from 'react'

export type BillingPeriodPillTheme = {
  border: string
  progressFill: string
  upcomingFill: string
}

const dotStyle = {
  width: '3px',
  height: '3px',
  borderRadius: '100%'
}

export const getProgressFillWidth = (props: {
  startOfPeriodOffset: number
  endOfPeriodOffset: number
  progressOffset: number
}): number => {
  if (props.startOfPeriodOffset > props.progressOffset) {
    return 0
  }

  if (props.endOfPeriodOffset < props.progressOffset) {
    return props.endOfPeriodOffset - props.startOfPeriodOffset
  }

  return props.progressOffset - props.startOfPeriodOffset
}

export const BillingPeriodPill = (props: {
  theme: BillingPeriodPillTheme
  progressFillWidth?: number
  openEndedFillWidth?: number
  isInAdvance?: boolean
  isMinimum?: boolean
  isProrated?: boolean
  isOneTime?: boolean
  width: number
  onMouseEnter?: MouseEventHandler<HTMLDivElement>
  onMouseLeave?: MouseEventHandler<HTMLDivElement>
}) => {
  return (
    <Box
      height="16px"
      position="relative"
      borderRadius="4px"
      border={`1px solid ${props.theme.border}`}
      backgroundColor={props.theme.upcomingFill}
      overflow="hidden"
      width={`${props.width}px`}
      pointerEvents={props.onMouseEnter || props.onMouseLeave ? 'auto' : 'none'}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      {Boolean(props.progressFillWidth) && (
        <Box
          position="absolute"
          top="0"
          bottom="0"
          left="0"
          background={props.theme.progressFill}
          width={`${props.progressFillWidth}px`}
          borderRight={`1px solid ${props.theme.border}`}
          zIndex={1}
        ></Box>
      )}
      {Boolean(props.openEndedFillWidth) && (
        <Box
          position="absolute"
          top="0"
          bottom="0"
          right="0"
          background={`repeating-linear-gradient(-45deg, transparent 6px, ${props.theme.border} 7px, transparent 8px, transparent 12px)`}
          width={`${props.openEndedFillWidth}px`}
          borderLeft={`1px solid ${props.theme.border}`}
          zIndex={2}
        ></Box>
      )}
      {props.isInAdvance && (
        <Box
          position="absolute"
          top="0"
          bottom="0"
          left="0"
          width={`4px`}
          background={props.theme.border}
          zIndex={3}
        ></Box>
      )}
      {props.isMinimum && (
        <Box
          position="absolute"
          bottom="0"
          left="0"
          right="0"
          height={`2px`}
          background={props.theme.border}
          zIndex={4}
        ></Box>
      )}
      {props.isProrated && (
        <Flex
          position="absolute"
          top="0"
          bottom="0"
          left="0"
          width="100%"
          alignItems="center"
          justifyContent="center"
          zIndex={5}
          gap="2px"
        >
          <Box {...dotStyle} backgroundColor={props.theme.border}></Box>
          <Box {...dotStyle} backgroundColor={props.theme.border}></Box>
        </Flex>
      )}
      {props.isOneTime && (
        <Flex
          position="absolute"
          top="0"
          bottom="0"
          left="8px"
          width="100%"
          alignItems="center"
          zIndex={5}
          gap="2px"
        >
          <Box {...dotStyle} backgroundColor={props.theme.border}></Box>
        </Flex>
      )}
    </Box>
  )
}
